import { render, staticRenderFns } from "./my-matches.vue?vue&type=template&id=36d3e1f0&scoped=true&"
import script from "./my-matches.vue?vue&type=script&lang=js&"
export * from "./my-matches.vue?vue&type=script&lang=js&"
import style0 from "./my-matches.vue?vue&type=style&index=0&id=36d3e1f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3e1f0",
  null
  
)

export default component.exports